/**
 * Timenet GEO (Generative Engine Optimization) Script
 *
 * WordPress (Bedrock/Sage): add via functions.php or WPCode plugin
 * <script src="/js/geo-llm-timenet.js" defer></script>
 */

(function () {
  'use strict';

  var BASE = 'https://www.timenet.it';

  // 1. Link to llms.txt
  var link1 = document.createElement('link');
  link1.rel = 'author';
  link1.type = 'text/plain';
  link1.href = BASE + '/llms.txt';
  link1.title = 'LLM-friendly site description';
  document.head.appendChild(link1);

  // 2. Link to llms-full.txt
  var link2 = document.createElement('link');
  link2.rel = 'alternate';
  link2.type = 'text/plain';
  link2.href = BASE + '/llms-full.txt';
  link2.title = 'LLM full context';
  document.head.appendChild(link2);

  // 3. JSON-LD Organization
  var jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Timenet SpA',
    'url': 'https://www.timenet.it',
    'logo': 'https://www.timenet.it/app/uploads/2023/04/logo.svg',
    'description': 'Operatore italiano di telecomunicazioni business. Connettività Internet, VoIP, sicurezza informatica, servizi cloud e mobile per aziende. Oltre 25 anni di esperienza e 7000+ clienti soddisfatti. Connessi, Sicuri, Soddisfatti.',
    'foundingDate': '1996',
    'numberOfEmployees': {
      '@type': 'QuantitativeValue',
      'minValue': 50,
      'maxValue': 99
    },
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'Via G. Di Vittorio 8',
      'addressLocality': 'Empoli',
      'addressRegion': 'FI',
      'postalCode': '50053',
      'addressCountry': 'IT'
    },
    'telephone': '+39057117380000',
    'vatID': 'IT04733650487',
    'founder': {
      '@type': 'Person',
      'name': 'Franco Iorio',
      'jobTitle': 'Presidente'
    },
    'sameAs': [
      'https://it.linkedin.com/company/timenet-spa',
      'https://www.facebook.com/Timenetsrl/'
    ],
    'knowsAbout': [
      'Business Internet Connectivity',
      'VoIP Telephony',
      'Cybersecurity',
      'Cloud Firewall',
      'Business Continuity',
      'Fiber Optic',
      'FWA 5G',
      'Satellite Connectivity',
      'Virtual PBX',
      'Managed VPN',
      'IoT Connectivity',
      'Business Mobile SIM'
    ],
    'hasOfferCatalog': {
      '@type': 'OfferCatalog',
      'name': 'Timenet Services',
      'itemListElement': [
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Naviga© Sicuro', 'url': 'https://www.timenet.it/ti-presentiamo-naviga/naviga-sicuro/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Naviga© Connesso', 'url': 'https://www.timenet.it/ti-presentiamo-naviga/naviga-connesso/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Cloud Firewall', 'url': 'https://www.timenet.it/cloud-firewall-timenet/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'VoIP Business', 'url': 'https://www.timenet.it/voip/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Centralino Virtuale', 'url': 'https://www.timenet.it/centralino-virtuale/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Timenet Mobile Pro', 'url': 'https://www.timenet.it/timenet-mobile-sim-dati-voce/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Security First', 'url': 'https://www.timenet.it/security-first/' } },
        { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Business Continuity', 'url': 'https://www.timenet.it/business-continuity/' } }
      ]
    },
    'subOrganization': {
      '@type': 'Organization',
      'name': 'Beliven Srl',
      'url': 'https://beliven.com',
      'description': 'Software factory specializzata in sviluppo software, app mobile, AI e soluzioni digitali.'
    }
  };

  var script1 = document.createElement('script');
  script1.type = 'application/ld+json';
  script1.textContent = JSON.stringify(jsonLd);
  document.head.appendChild(script1);

  // 4. Meta tag AI discoverability
  if (!document.querySelector('meta[name="ai-content-declaration"]')) {
    var meta = document.createElement('meta');
    meta.name = 'ai-content-declaration';
    meta.content = 'llms.txt available at /llms.txt';
    document.head.appendChild(meta);
  }

})();
